import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Calculator from '@/pages/Calculator';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminLeadDetail from '@/pages/AdminLeadDetail';
import AdminSettings from '@/pages/AdminSettings';
import AdminUsers from '@/pages/AdminUsers';
import AdminProfile from '@/pages/AdminProfile';
import Impressum from '@/pages/Impressum';
import Datenschutz from '@/pages/Datenschutz';
import { Toaster } from '@/components/ui/sonner';
import { LanguageProvider } from '@/i18n';

function App() {
  return (
    <LanguageProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/calculator" replace />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/leads/:id" element={<AdminLeadDetail />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/profile" element={<AdminProfile />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
    </LanguageProvider>
  );
}

export default App;
